var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draft-live-footer"},[_c('div',{staticClass:"footer-content"},[_vm._t("left"),_vm._t("center"),_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }